export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-light-7cc1f863fcbfb28188da536faee9468b.png";